import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { budapestNow, slotRange } from "@/lib/schedule";

export function useSchedule() {
  const [data, setData] = useState(null);
  const [tick, setTick] = useState(0);
  useEffect(() => { api.get("/schedule").then((r) => setData(r.data)).catch(() => setData({ slots: {} })); }, []);
  useEffect(() => { const id = setInterval(() => setTick((t) => t + 1), 30000); return () => clearInterval(id); }, []);
  const now = budapestNow();
  const raw = data?.slots || {};
  const slots = raw;
  const act = (k) => (raw[k] || []).filter((e) => !e.cancelled);
  const current = act(`${now.day}-${now.slot}`);
  let next = null;
  for (let i = 1; i <= 84 && !next; i++) {
    const idx = now.day * 12 + now.slot + i;
    const day = Math.floor(idx / 12) % 7;
    const slot = idx % 12;
    if (act(`${day}-${slot}`).length) {
      const r = slotRange(day, slot);
      if (day < now.day || (day === now.day && slot <= now.slot)) { r.start = new Date(r.start.getTime() + 7 * 86400000); r.end = new Date(r.end.getTime() + 7 * 86400000); }
      next = { day, slot, entries: act(`${day}-${slot}`), ...r };
    }
  }
  return { loaded: !!data, slots, now, current, next, tick };
}
